import { Session } from '@ais-ui/auth';

import { Bookmark } from './types';

export const saveBookmark = async (
  session: Session,
  bookmark: Bookmark,
): Promise<string> => {
  const response = await session.request('saveBookmark', {
    bookmark,
  });

  return response;
};
